/**
 * Image Switcher
 *
 * Author : T.Tomida <tomida@linkainc.jp>
 * Company : LINKA ASSOCIATES INC.
 * Copyright : Copyright(c) 2018 LINKA ASSOCIATES INC.
 * Ver : 2.0.0
 */
export default class ImgSwitcher {
	// 初期設定
	constructor(targetObj, params) {
		var that = this;
		if ('data' in this) {
			clearInterval(this.data.intervalId);
		}
		$(window).off('resize.imgSwitcher');
		this.data = {};
		var dataObj = Object.assign({}, this.dataDefaults(), params);
		var skipLen;
		dataObj.targetObj = targetObj;
		dataObj.mainObj = dataObj.targetObj.find('.' + dataObj.mainClass).first();
		dataObj.mainInnerObj = dataObj.targetObj.find('.' + dataObj.mainInnerClass).first();
		dataObj.thumbObj = dataObj.targetObj.find('.' + dataObj.thumbClass).first();
		dataObj.itemCount = dataObj.mainInnerObj.children().length;
		dataObj.cursorLeftObj = dataObj.targetObj.find('.' + dataObj.cursorLeftClass).first();
		dataObj.cursorRightObj = dataObj.targetObj.find('.' + dataObj.cursorRightClass).first();
		this.setZoom();
		this.tmpData = {}
		this.touchTmpData = {}
		dataObj.itemData = [];
		//dataObj.targetObj.css('visibility', 'hidden');
		if (dataObj.itemCount <= 1) {
			dataObj.autoChange = false;
			dataObj.cursorLeftObj.addClass('is-hide');
			dataObj.cursorRightObj.addClass('is-hide');
		}

		var imgPathList = [];
		dataObj.mainInnerObj.find('img').each(function () {
			imgPathList.push($(this).attr('src'));
		});

		this.data = dataObj;

		// 全て無事読み込みが完了した時の処理
		this.preload(imgPathList)
			.then(() => {
				switch (dataObj.changeMode) {
					case 'fade':
						dataObj.maxZ = dataObj.itemCount;
						dataObj.mainInnerObj.css('position', 'relative');
						dataObj.activeNum = 0;
						dataObj.mainInnerObj.children().each(function (key, value) {
							$(this).css({
								position: 'absolute',
								left: '0px',
								top: '0px',
								zIndex: dataObj.itemCount - key
							});
						});
						dataObj.thumbObj.children().removeClass('active').first().addClass('active');
						skipLen = 0;

						break;
					case 'slide':
						dataObj.mainObjSize = dataObj.mainObj.width();
						dataObj.itemSize = dataObj.mainInnerObj.children().first().outerWidth(true);
						dataObj.activeNum = 0;
						dataObj.thumbObj.children().removeClass('active').eq(dataObj.activeNum).addClass('active');
						dataObj.cursorLeftObj.addClass('is-hide');
						setTimeout(function () {
							dataObj.mainInnerObj.css('transition', `transform ${dataObj.changeSpeed / 1000}s ease`);
						}, 400);
						break;
					case 'slide-loop':
						dataObj.blockNum = 1; // スライドセットのブロック初期値
						dataObj.mainObjSize = dataObj.mainObj.width();
						dataObj.itemSize = dataObj.mainInnerObj.children().first().outerWidth(true);
						dataObj.activeNum = 0;
						var slideTmpObjs = dataObj.mainInnerObj.children().clone();
						dataObj.mainInnerObj
							.find('.before,.after').remove();
						dataObj.mainInnerObj
							.prepend(slideTmpObjs.clone().addClass('before'))
							.append(slideTmpObjs.clone().addClass('after'));
						//dataObj.mainInnerObj.width(dataObj.itemSize * dataObj.itemCount * 3);
						skipLen = dataObj.itemSize * dataObj.itemCount;
						dataObj.mainInnerObj.css('transform', `translateX(${-1 * skipLen}px)`);
						dataObj.thumbObj.children().removeClass('active').not('.before,.after').eq(dataObj.activeNum).addClass('active');
						setTimeout(function () {
							dataObj.mainInnerObj.css('transition', `transform ${dataObj.changeSpeed / 1000}s ease`);
						}, 400);
						break;
				}

				if (dataObj.defaultSlideNum) {
					that.imgSwichAction({
						num: dataObj.defaultSlideNum,
						loopFlg: false,
					});
				}

				dataObj.mainInnerObj.children().each(function (key, value) {
					dataObj.itemData.push({
						pos: -1 * dataObj.itemSize * key,
						obj: $(value),
						width: $(value).outerWidth(),
						num: key % dataObj.itemCount
					});
				});

				if (dataObj.touch && ('ontouchstart' in window)) {
					that.setTouch();
				}
				if (dataObj.autoChange) {
					that.autoSwitchAction(); // 自動切り替えをリセット
					// マウスオーバー時は自動切り替えを停止
					if (dataObj.hoverChangeStop) {
						dataObj.mainObj.hover(
							function () {
								clearInterval(dataObj.intervalId);
							},
							function () {
								that.autoSwitchAction();
							}
						);
					}
				}
				if (!!dataObj.initAfter) {
					dataObj.initAfter(this);
				}
				//dataObj.targetObj.css('visibility', 'visible');
			});

		dataObj.thumbObj.children().on('click', function () {
			var index = dataObj.thumbObj.children().index(this);
			that.imgSwichAction({
				num: index,
				loopFlg: false,
			});
		});

		dataObj.cursorLeftObj.on('click', function () {
			console.log('left click')
			that.imgSwichAction(that.prevNum());
		});
		dataObj.cursorRightObj.on('click', function () {
			that.imgSwichAction(that.nextNum());
		});

		/*
		let timer = null;
		$(window).on('resize.imgSwitcher',function(){
			clearTimeout(timer);
			targetObj.html(targetObj.html());
			timer = setTimeout(function() {
				that.constructor(targetObj,params);
			},300)
		});
		*/
	}
	// 基本値
	dataDefaults() {
		return {
			mainClass: 'pickup', // メイン画像表示エリアのクラス
			mainInnerClass: 'pickup', // メイン画像の内包クラス
			thumbClass: 'thumbnail', // サムネイル表示エリアのクラス
			cursorLeftClass: 'cursor-left', // 左カーソルのクラス
			cursorRightClass: 'cursor-right', // 右カーソルのクラス
			changeMode: 'fade', // スライド切替の方法（fade,slide,slide-loop）
			term: 5000, // 切替インターバル時間（ミリ秒）
			changeSpeed: 400, // 切替開始から完了までの時間（ミリ秒）
			touch: true, //タッチデバイス対応
			swipe: true, //スワイプ操作対応
			transform: false,
			autoChange: false, // 自動切り替えの有効無効
			linkFlg: false,
			initAfter: function () { },
			reloadFlg: false,
			imgResize: true,
			hoverChangeStop: true, // マウスホバー時に画像切替を止める,
			defaultSlideNum: 0, // スライド初期値,
			imgChangeFunc: null
		}
	}
	// 自動切り替え動作
	autoSwitchAction() {
		var that = this;
		var data = this.data;
		if (data.intervalId) {
			clearInterval(data.intervalId);
		}
		data.intervalId = setInterval(function () {
			that.imgSwichAction(that.nextNum(false, true)); // 自動切り替えの時はループ処理するよう第2引数にフラグを渡す
		}, data.term);
	}
	autoSwitchStop() {
		clearInterval(this.data.intervalId);
	}
	// 画像切替動作
	imgSwichAction(numData) {
		var data = this.data;
		var touchData = data.touchData;
		var that = this;
		if (numData.num === void 0) {
			return false;
		}
		if (!!numData.num && numData.num > data.itemCount - 1) { // 指定番号があるかどうか
			numData = this.nextNum();
		}
		if (!numData.speed) {
			numData.speed = data.changeSpeed;
		}
		if (data.autoChange) {
			this.autoSwitchAction(); // 自動切り替えをリセット
		}
		switch (data.changeMode) {
			case 'fade':
				data.maxZ = Number(data.maxZ) + 1;
				data.mainInnerObj.children().eq(numData.num).hide().stop().fadeIn(data.changeSpeed).css({
					zIndex: data.maxZ
				});
				break;
			case 'slide':
				var pos = this.num2pos(numData.num);
				var decision = -1 * (data.itemSize - 1) * data.itemCount + data.mainObjSize;
				data.cursorRightObj.removeClass('is-hide');
				data.cursorLeftObj.removeClass('is-hide');
				if (numData.num === 0) {
					data.cursorLeftObj.addClass('is-hide');
				}
				if (decision > pos) {
					data.cursorRightObj.addClass('is-hide');
				}
				data.mainInnerObj.stop().css('transform', `translateX(${pos}px)`);
				break;
			case 'slide-loop':
				var pos;
				if (numData.loopFlg) {
					pos = this.num2pos(numData.num, numData.dir === 'next' ? 2 : 0);
				} else {
					pos = this.num2pos(numData.num, 1);
				}
				data.mainInnerObj.off('transitionend')
				data.mainInnerObj.stop()
					.css({
						'transition-property': 'all',
						transform: `translateX(${pos}px)`
					})
					.on('transitionend', function () {
						if ((numData.num == 0 && numData.dir == "next") || (numData.num == (data.itemCount - 1) && numData.dir == "prev")) {
							let pos = that.num2pos(numData.num, 1);
							data.mainInnerObj.stop().css({
								'transition-property': 'none',
								transform: `translateX(${pos}px)`
							})
						}
					});
				break;
		}
		data.mainInnerObj.children().removeClass('active').not('.before,.after').eq(numData.num).addClass('active');
		data.thumbObj.children().removeClass('active').not('.before,.after').eq(numData.num).addClass('active');
		data.activeNum = numData.num;

		if (data.imgChangeFunc) {
			data.imgChangeFunc(numData.num)
		}
	}
	// 次のスライド番号を返す
	nextNum(speed) {
		var data = this.data;
		if (data.activeNum < data.itemCount - 1) {
			return {
				num: Number(data.activeNum) + 1,
				loopFlg: false,
				dir: 'next',
				speed: speed
			};
		} else {
			if (data.changeMode === 'slide' && !arguments[1]) {
				return {
					num: data.activeNum,
					loopFlg: false,
					dir: 'next',
					speed: data.changeSpeed / 2
				};
			} else {
				return {
					num: 0,
					loopFlg: true,
					dir: 'next',
					speed: speed
				};
			}
		}
	}
	// 前のスライド番号を返す
	prevNum(speed) {
		var data = this.data;
		if (data.activeNum !== 0) {
			return {
				num: Number(data.activeNum) - 1,
				loopFlg: false,
				dir: 'prev',
				speed: speed
			};
		} else {
			if (data.changeMode === 'slide') {
				return {
					num: 0,
					loopFlg: false,
					dir: 'prev',
					speed: data.changeSpeed / 2
				};
			} else {
				return {
					num: data.itemCount - 1,
					loopFlg: true,
					dir: 'prev',
					speed: speed
				};
			}
		}
	}
	num2pos(num) {
		var data = this.data;
		if (arguments[1]) {
			return -1 * data.itemSize * (arguments[1] * data.itemCount + num);
		} else {
			return -1 * data.itemSize * num;
		}
	}

	// ポジションから表示するスライドを決定
	getRenderByPos(pos) {
		var data = this.data;
		var current = {
			num: data.activeNum,
			loopFlg: false,
			speed: data.changeSpeed / 2
		}
		var tmp = {};
		var itemBlockSize = data.itemSize * data.itemCount;
		$.each(data.itemData, function (key, value) {
			if (value.pos < pos && pos < (Number(value.pos) + value.width)) {
				switch (data.changeMode) {
					case 'slide-loop':
						if (pos > -1 * itemBlockSize + data.itemSize && data.activeNum !== value.num) {
							tmp = {
								num: data.itemCount - 1,
								loopFlg: true,
								dir: 'prev',
							}
							return false;
						}
						if (-2 * itemBlockSize + data.itemSize > pos && data.activeNum !== value.num) {
							tmp = {
								num: 0,
								loopFlg: true,
								dir: 'next'
							}
							return false;
						}
						break;
					default:
				}
				tmp = {
					num: value.num,
					loopFlg: false,
					dir: data.activeNum < value.num ? 'next' : 'prev',
					speed: data.changeSpeed
				};
				return false;
			}
		});
		$.extend(current, tmp);
		if (current.num === 0 && current.num === data.activeNum) {
			current.speed = data.changeSpeed / 2;
		}
		if (current.num === data.itemCount - 1 && current.num === data.activeNum) {
			current.speed = data.changeSpeed / 2;
		}

		return current;
	}

	// タッチデバイス処理基本設定
	setTouch() {
		var that = this;
		var dataObj = this.data;
		var posNum;

		dataObj.touchData = {};
		dataObj.touchData.boxCount = 0;
		dataObj.touchData.position = [];// 要素の位置を記録

		switch (dataObj.changeMode) { // タッチ操作時のmove動作の有効／無効判定 と 指定要素の削除
			case 'fade':
				dataObj.touchData.move = false;
				posNum = 0;
				break;
			case 'slide':
				posNum = 0;
				break;
			case 'slide-loop':
				dataObj.touchData.move = true;
				posNum = 1;
				break;
		}

		dataObj.mainInnerObj.children().on('mousedown touchstart', function (e) {
			if (!e.changedTouches) return;
			var targetObj = this;
			var touchFlg = true;
			var tmpData = that.touchTmpData;
			var touchData = dataObj.touchData;
			//e.preventDefault();
			var gestureX = e.changedTouches[0].pageX// X 座標の位置
			var startY = e.changedTouches[0].pageY// Y 座標の位置
			var totalMoveY = 0;
			tmpData.drag = true;
			clearInterval(dataObj.intervalId);
			var date = new Date();
			tmpData.dragStartTime = date.getTime();
			tmpData.pos = dataObj.mainInnerObj.offset().left;
			tmpData.weight = 1;
			tmpData.moveLen = 0;
			tmpData.lock = null;

			if (dataObj.changeMode === 'slide' && dataObj.activeNum === 0) {
				tmpData.weight = 0.3;
				tmpData.dir = -1;
			}
			if (dataObj.changeMode === 'slide' && dataObj.activeNum === dataObj.itemCount - 1) {
				tmpData.weight = 0.3;
				tmpData.dir = 1;
			}
			dataObj.mainInnerObj.stop().css({ 'transition-property': 'none' })

			$(document).on('mousemove.slider touchmove.slider', function (e) {
				var touchEvent = e;
				var moveObj = {};

				tmpData.dragPos = e.changedTouches[0].pageX;// X 座標の位置
				tmpData.moveLen = tmpData.dragPos - gestureX;
				tmpData.moveLen = tmpData.moveLen * tmpData.dir < 0 ? tmpData.moveLen * tmpData.weight : tmpData.moveLen; //X座標の移動量
				tmpData.moveLen = tmpData.moveLen / that.data.zoom;
				tmpData.pos = tmpData.moveLen + that.num2pos(dataObj.activeNum, posNum);

				var moveY = event.changedTouches[0].pageY;// Y 座標の位置
				var diffY = moveY - startY;
				totalMoveY += diffY;

				// 縦スクロール時は横移動しないようロックをかける
				if (tmpData.lock === null) {
					tmpData.lock = Math.abs(diffY) > Math.abs(tmpData.moveLen) ? false : true;
				}

				moveObj = { 'transform': `translateX(${tmpData.pos}px)` };

				if (tmpData.lock) {
					//touchEvent.preventDefault();
					dataObj.mainInnerObj.stop().css(moveObj);
				}
				return true;
			})
				.one('mouseup touchend', function (e) {
					if (!touchFlg) {
						return false;
					}
					dataObj.mainInnerObj.stop().css({ 'transition-property': 'all' })
					touchFlg = false;
					$(document).off('mousemove.slider touchmove.slider');
					var moveObj = {};
					var date = new Date();
					tmpData.dragEndTime = date.getTime();
					var moveDir = tmpData.moveLen > 0 ? -1 : 1;
					/*
					if (Math.abs(tmpData.moveLen) < 5) { // 移動距離が軽微な入力の場合
						if (tmpData.dragEndTime - tmpData.dragStartTime < 300) { // click処理判定
							var $anchorObj = $(targetObj).closest('a');
							if ($anchorObj.length && $anchorObj.prop('tagName') === 'A') {
								$anchorObj[0].click();
							} else {
								that.imgSwichAction(dataObj.activeNum);
							}
						} else {
							that.imgSwichAction(dataObj.activeNum);
						}
						return false;
					}
					*/
					// スワイプ処理
					if (dataObj.swipe && (tmpData.dragEndTime - tmpData.dragStartTime < 300 && Math.abs(tmpData.moveLen) > 30)) {
						var speed = that.getMoveSpeed(Math.abs(tmpData.moveLen), (tmpData.dragEndTime - tmpData.dragStartTime));
						that.imgSwichAction(moveDir > 0 ? that.nextNum(speed) : that.prevNum(speed));
						return false;
					}
					if (tmpData.moveDir === 0) {
						dataObj.mainInnerObj.stop().css({
							'transform': `translateX(${tmpData.pos}px)`
						});
					}
					switch (dataObj.changeMode) {
						case 'fade':
							that.imgSwichAction(moveDir > 0 ? that.nextNum() : that.prevNum());
							break;
						case 'slide':
						case 'slide-loop':
							that.imgSwichAction(that.getRenderByPos(that.num2pos(dataObj.activeNum, posNum) + tmpData.moveLen + dataObj.itemSize / 2));
							break;
					}
					return true;
				});
			return true;
		});
	}
	getMoveSpeed(moveLen, moveTime) {
		var data = this.data;

		return (moveTime * (data.itemSize - moveLen)) / moveLen;
	}

	setZoom() {
		var that = this;
		$(window).on('resize load', function () {
			setTimeout(function () {
				that.data.zoom = $("html").css("zoom");
			}, 100)
		});
	}
	// 画像の先読み関数
	preload(imgPathList) {
		return Promise.all(imgPathList.map(_path => {
			return new Promise((resolve, reject) => {
				let img = new Image()
				img.onload = () => {
					resolve();
				}
				img.onerror = () => {
					reject();
				}
				img.src = _path;
			})
		}))
	}
}